import React from 'react';
import { useStore } from '../../store/Store';
import { logout } from '../../store/ActionLogin';

export const AdminHeader = () => {
  const {
    state: { user },
    dispatch
  } = useStore();

  return (
    <div className="Admin__header">
      <div className="header__item">{user.displayName}</div>
      <div className="header__item dropdown">
        <img
          src={user.avatar}
          className="Admin__avatar dropdown-toggle"
          type="button"
          id="dropdownMenuButton"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          alt="Avatar usuario"
        />

        <div
          className="dropdown-menu Admin__userMenu"
          aria-labelledby="dropdownMenuButton"
        >
          <button
            className="btn dropdown-item"
            onClick={() => logout(dispatch)}
          >
            Salir
          </button>
        </div>
      </div>
    </div>
  );
};
